
<div :class="jel_getClassObject(content)">
  <!-- TODO: si content.modeInscription == 'inscription' 
             alors ajouter validation de non-existence
             + permettre la saisie du username (à confirmer) -->
  <!-- tag="div" nécessaire pour accessibilité, éviter div dans un span -->
  <ValidationProvider
    v-slot="validationContext"
    :name="content.libNomUtilisateur"
    rules="max:128"
    tag="div"
  >
    <b-form-group :label="content.libNomUtilisateur" label-for="nomUtilisateur">
      <b-form-input
        :id="content.idHTML ? content.idHTML : 'nomUtilisateur'"
        v-model="nomUtilisateur"
        v-remove-extra-spaces
        trim
        maxlength="128"
        type="text"
        autocomplete="off"
        :state="getValidationState(validationContext)"
      />
      <ErreurValidation
        id="nomUtilisateur-live-feedback"
        :message="validationContext.errors[0]"
      ></ErreurValidation>
    </b-form-group>
  </ValidationProvider>
</div>
